import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { DomHandler } from 'primeng/dom';

@Component({
  selector: 'iu-modal-ui',
  templateUrl: './modal-ui.component.html',
  styleUrls: ['./modal-ui.component.scss']
})
export class ModalUiComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string;
  @Input() hasCloseBtn = false;
  @Input() closeBtnLabel = 'generic.close';
  @Input() angularStyle: any;
  @Input() isSearch = false;
  @Input() isModalDisplay = true;
  @Input() modalClass = 'p-col-10 p-md-10 p-lg-10';
  @Input() isLoading = false;
  @Input() appendTo = null;
  @ViewChild('container', { static: true }) containerViewChild: ElementRef;
  @Output() closeModalEmitter = new EventEmitter<any>();
  @Input() contentType: ModalContentType.WINDOW;

  isCloseInit = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {}
  ngAfterViewInit() {
    if (this.appendTo) {
      if (this.appendTo === 'body') {
        document.body.appendChild(this.containerViewChild.nativeElement);
      } else {
        DomHandler.appendChild(this.containerViewChild.nativeElement, this.appendTo);
      }
    }
  }
  ngOnDestroy() {
    if (this.isModalDisplay) {
      this.closeModalEmitter.emit();
      if (this.isModalDisplay) {
        this.isModalDisplay = false;
      }
    }

    if (this.appendTo) {
      this.el.nativeElement.appendChild(this.containerViewChild.nativeElement);
    }
  }
  close($event: MouseEvent, fromCloseBtn = false) {
    if ((!fromCloseBtn && ($event.target as any).classList.contains('iu-modal-background') === true) || fromCloseBtn) {
      $event.stopPropagation();
      this.closeModalEmitter.emit();
      if (this.isModalDisplay) {
        this.isModalDisplay = false;
      }
    }
  }

  initClose($event: MouseEvent) {
    if (($event.target as any).classList.contains('iu-modal-background') === true) {
      this.isCloseInit = true;
      const a = this.renderer.listen(document.documentElement, 'mouseup', ($e: MouseEvent) => {
        this.close($e);
        this.isCloseInit = false;
        a();
      });
    }
  }
}
export enum ModalContentType {
  WINDOW = 'window',
  PROCESS = 'process',
  FORM = 'form',
  JOINFILE = 'joinFiles'
}
